import useSWR from "swr";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { ServicesURL } from "@utils/utilsApi";
import { CatalogEntityType, DraftListItem, draftEntityType } from "../types";

interface UseDraftDetailArgs {
  corporateId: string;
  draftId: string;
}

const swrFetcher = (url: string) => fetcher(url, MethodType.GET);

export const useDraftDetail = ({
  corporateId,
  draftId,
}: UseDraftDetailArgs) => {
  const url =
    corporateId && draftId
      ? ServicesURL.v2DraftById
          .replace(":idCorporate", corporateId)
          .replace(":id", draftId)
      : null;

  const { data, error, isLoading } = useSWR<DraftListItem>(url, swrFetcher);

  const wizard: any = data?.data?.__draft?.wizard ?? null;
  const type: CatalogEntityType | null = data ? draftEntityType(data) : null;

  return { draft: data, wizard, type, isLoading, error };
};
